module.exports = __webpack_public_path__ + "band_11.8352accf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/band_11.png
// module id = y1mj
// module chunks = 0